// extracted by mini-css-extract-plugin
export default {"AppContainer":"AppContainer_AppContainer__s2nwX","main":"AppContainer_main__Ra-jO"};